// extracted by mini-css-extract-plugin
export default {"contentContainer":"PolicyBasic_contentContainer__yMS9Z","background":"PolicyBasic_background__iffw3","containcontentContainerer":"PolicyBasic_containcontentContainerer__rTGlh"};